// Editorial selection from https://www.youtube.com/@objavujsvetSK, reviewed 2026-11-04.
// 298 public channel videos inventoried; all 121 selected embeds passed YouTube oEmbed
// with author_url=https://www.youtube.com/@objavujsvetSK. Company clips are labelled
// separately in the UI and never presented as footage of an unfilmed destination.
// Update this selection when the channel adds destination footage; do not auto-search YouTube.

export const OFFICIAL_CHANNEL_VIDEO_IDS: readonly string[] = [
  '-CIr-xbcWO0',
  '-oSBIdJWlk0',
  '-qvtkZNte4w',
  '0QNDBsCiPLs',
  '0ocZWbWS15Y',
  '100BW1D3tj8',
  '1TUSTsEWolw',
  '1doNK-IMutI',
  '20EG869oyk4',
  '2DkQJVA6hWw',
  '2u2-3Mze4tk',
  '3BAxGovm5GU',
  '3QrvMUf_kik',
  '3Sz3rQ-U5pw',
  '3UbMqdubGV0',
  '3gxM2xYBrBM',
  '3jqYY1LY3M4',
  '3sgX41X70kU',
  '3viVAMT6FRA',
  '426OXHA0ZZc',
  '4FF1Ve6kyec',
  '4bzhv6ZZNMM',
  '4rMgSKqZrTA',
  '51c-JUdK-2k',
  '54xydJcnns8',
  '5k2R3N54msg',
  '64HJRlNSzrY',
  '6BX-c21IFLI',
  '6iHYy6-Y-_Q',
  '7F-qcwgdpzc',
  '7FgxftUl6Xc',
  '7Fy8DVKahb4',
  '7Y0UPF5o8JY',
  '7emi9UjGTkE',
  '7gdmel6uS_k',
  '7juFcAnDauA',
  '7sVcbcFSnks',
  '80ybNLiAoZw',
  '8E-15dO-HWc',
  '8YLn0osY8c0',
  '8vqXJ5tcKkc',
  '9RSKSNpQYUU',
  '9X-BCb6DViQ',
  'A5uSUIq6R30',
  'A6yvJ4zzpy0',
  'ANgsVbd7IWo',
  'ApeaPwlad-U',
  'AqdYE6AT-q4',
  'ArAUCsUhLiI',
  'ArzL7Dz6vqg',
  'BWHWjx_Paq0',
  'Ba-iPo5qcOk',
  'C2MO0FEh4PA',
  'C94GuMnvf6A',
  'CDqgIdEAMIA',
  'CEoIrHUnkqk',
  'CErnCW3JGzg',
  'CKrumt9kUM4',
  'Cr0Yequ4ZBE',
  'DCC9yt4WrgU',
  'DE0RGw_rB_o',
  'DOUFbuLLQDs',
  'E-1xRpmr3U4',
  'E2EURlliHLk',
  'EDyzumnZmIw',
  'EHjRZ7adCr0',
  'EcpELsdDhNo',
  'Eo9jyrS9jDE',
  'EscERw4rdy8',
  'EyOKQRMEwfk',
  'FUOuEjp2h8g',
  'FVFrstXXcpA',
  'FclohgWM31w',
  'FgyBrdDxURw',
  'FnHFp7klKVM',
  'FouIXLftj6s',
  'Fw73XloSoN0',
  'G-tFOld6-Wc',
  'GJb9Ne7QfEI',
  'GVcbrvfD774',
  'GZ-KsdgA6g4',
  'GgFD4yUFBbM',
  'GkUI9Py8QXA',
  'Gx9zFHrJmJY',
  'H-k2-8ysfxg',
  'H1HgEnA2DfI',
  'HxZiPC0u6Bo',
  'IU6V77JsI4g',
  'IbfHNMz_Vp8',
  'IfDXvr6gQZI',
  'ImqjKnuJCE0',
  'J1cDW_KYjnY',
  'JBtclOWgP-0',
  'JKmeLy1WWjI',
  'JVpWxBe9zno',
  'Jz8uhVwMfKU',
  'K5Fhhf_424s',
  'KPqSbOiu3Lg',
  'KR1WvSwBPcI',
  'KSH8fD0lV1Y',
  'L4UZF0MU9cM',
  'L8wiIPBj-J8',
  'LIyecHA5PMg',
  'LjlyGwxUEXA',
  'MHiR62kTRDg',
  'MIkg0e8YbPY',
  'Mb1gRFUuQVY',
  'NFV106ZQpJQ',
  'NFs_CDgumjc',
  'NQ1uOptLqwI',
  'NWyNWELATkw',
  'NfQ3p364KI4',
  'Nx4iB-_1SZ0',
  'OOwEVxHczvw',
  'OV5Tbpk9ApA',
  'OWlkg8s5wXQ',
  'OojdzrAuL7A',
  'P9Yv3bsfTuo',
  'PWJ8PSkRJTI',
  'P_PugZkpGAQ',
  'QBeV3J6XfSs',
  'QM-qpusUIcU',
  'QOrXXmKsMBM',
  'QUQyUyg53N0',
  'QiMIuNhYxsE',
  'R-N1syWfCrY',
  'R8qMh04Q5C4',
  'RE8a6v01aCw',
  'RWruQHTpCd0',
  'Rj0dYcGqJIo',
  'RwPJ5pgRWqY',
  'S1nHdkSyZtE',
  'SAeOGGPSljM',
  'Sc03PfAqYRA',
  'SfK5wTVeMJ8',
  'T99o7v4iEYk',
  'TBb8kW32YwU',
  'THW-okiEZE4',
  'TbtS-LPb0Cw',
  'Tt4hNiTAYzM',
  'TtL_yE_6oq8',
  'U7ZszGvgBL0',
  'UGbvxJA_2sM',
  'UcPKZKyMrt0',
  'UljN-0zJUls',
  'Uvu4awQePNg',
  'VfAiENZZChI',
  'ViUVv-j9YAk',
  'WJNSgDrjLBM',
  'WWxMEjd0Wsk',
  'WYEFZmTN4EE',
  'WmGm03J5wbM',
  'WsaTc71Am68',
  'XDZkcCEGSwk',
  'XGpieMr8aPY',
  'XIXQ2NXsbSE',
  'Xa2bPA-aUJE',
  'XcGPoCPiJrE',
  'XfNXc12cqvE',
  'Xnl0E5jnQSA',
  'Xy7PNRHIXjc',
  'Y9LzOCfG_AM',
  'YGznbUoH0eI',
  'YORLiNgcPIA',
  'YPN--G9p0hE',
  'YZVa3gyff-Y',
  'YguHNjf27g0',
  'YpAff0TKL4Q',
  'Z4-1BnapONs',
  'ZN30Swku17U',
  'ZS5h6bRA2NA',
  'ZbAn22PoIzs',
  'Zlkk_vOTiVM',
  'ZoSyFSGspCA',
  'Zt_MNjDj8D0',
  'Zxd9CQlX910',
  '_SAkgb8sICk',
  '_ga1l9P72fY',
  '_ncbxRd_Ujc',
  '_tcOfbDKzzc',
  '_uF5h1NLsts',
  '_wjJGoYsDCs',
  '_xGU9HaAgws',
  'aDHE3aRFEbk',
  'aZxcCGZfXXM',
  'bBQNwsCvKNk',
  'buV8ywK5F38',
  'c9cTZpRqXT8',
  'cDyIAB0n16A',
  'cH8qF88Rt-g',
  'd87PVaY7ux0',
  'dDP1h282cp4',
  'dos4Zmo36Eo',
  'dq3Fo9ksCCA',
  'dukZhJgme5Y',
  'dvJ0zZwfu9w',
  'dypEHjGbIKU',
  'e4cMem7wKFw',
  'eMZwuVVXo2E',
  'el_4o_BNJ2g',
  'ewtHheXgaAY',
  'f9U4jufjSpU',
  'fBWNeKUlU4Q',
  'ffrjuBzCcxc',
  'fhvVl7XPPC0',
  'g1i096KLPao',
  'gQgKBdbbre0',
  'gUaoKesTX7g',
  'gZZZ-Uy4Ubg',
  'gb7tXQk2zaM',
  'gs6TxgkdCtY',
  'gwPYnUn0reE',
  'h6wjx-SzTeQ',
  'h9BftwW5Tpw',
  'hNxBQ26aTTA',
  'hdqliblRSGY',
  'heMz7HeNkJ0',
  'hrzRzxk2_cs',
  'i-QoWpdhjlY',
  'i8jxhJDzNnc',
  'iu0FrKnwKt4',
  'iuO74CKdpH8',
  'j9SpsaoCBRM',
  'jNe2t2P87mo',
  'jYnsgW6CFOg',
  'j_8jWOa9KdI',
  'k35FCT6AFfk',
  'k35Nl2EOYxc',
  'kXwlASd11Kk',
  'lRjN_1WPaTA',
  'lTrRXfJMfNA',
  'lxwSLFQDDSA',
  'lyvF02fGHEY',
  'm4YAgEn0KIs',
  'mXMB99aO1k4',
  'mi_A0viPkIc',
  'nTKRPoS0Ka0',
  'nbOHRBbIeAE',
  'np4DGWLN7WY',
  'nskCEsw260I',
  'o2vpeuEPcdQ',
  'o8nA_rtTc0s',
  'oRVxjsqR9yE',
  'ondkeTWc-n4',
  'opPLqOeO5-A',
  'ozKFEAmwahs',
  'p16AVG7ySBY',
  'p6L9NlKOgQo',
  'pmW1a5XvoUA',
  'qEmUJKLrlXY',
  'qVHizUmgH-A',
  'qZ2PLhHDYCU',
  'q_ji13k58eE',
  'r6_Z6vIiOOg',
  'rPkjKmPZR34',
  'rXcP15Fm6PU',
  'rrE0SrVcvSU',
  'rzh5JGR8NkQ',
  's4__46FIvKw',
  'sEmEJL7Qbxg',
  'sRuDLtsBw1M',
  'sU5gdB8EwFg',
  'sUJ0wSB2jeA',
  'sYiB-bCitx8',
  's__xaisUDUs',
  'tf0OTuF7g-Y',
  'tymKTomXDNc',
  'u-GzAjS_H74',
  'u6o9ULFq6Ys',
  'u916SzxoQnQ',
  'ubWkJmdxd2I',
  'ueRy7NBRfns',
  'uen7bQESCH0',
  'uyA6UphQVfw',
  'vX4VpAraZMA',
  'vYBZmL4xpKA',
  'vZ4sY0yffzc',
  'vfMkgxfCVhE',
  'vuDYq_C8buo',
  'vy0S7Z5EjUY',
  'w-PJQGTtHS0',
  'wGSLBo_VOtU',
  'wc0yht0L9RU',
  'wiVGkv1Vk2E',
  'x2ODgkluXdY',
  'xIkL5-D9_B8',
  'xQ_h4uCmBlY',
  'xWI1QPCibDc',
  'y0Jlsb62sUQ',
  'y2UWHayaV60',
  'yDhZaF4pvPo',
  'yeT-DfXJeYQ',
  'z1bGCipVPEI',
  'z33BrzC3yNg',
  'z5SuQWTb2BY',
  'zSPOUJOznHU',
  'zfTeJbOWflE',
  'zs95ULzrqaU',
];

export const CURATED_VIDEO_NAMES: Readonly<Record<string, string>> = {
  '-qvtkZNte4w': 'Srí Lanka – škorica',
  '0ocZWbWS15Y': 'Maldivy – referencia cestovateľov',
  '100BW1D3tj8': 'Čo má Stanka najradšej na Madeire ?',
  '20EG869oyk4': 'Madeira - ostrov kvetov - raj na zemi',
  '2DkQJVA6hWw': 'S nami nie ste sami – spoznajte Objavuj svet',
  '3BAxGovm5GU': 'Japonsko – Kjóto',
  '3QrvMUf_kik': 'Skúsenosti našich cestovateliek',
  '426OXHA0ZZc': 'Flores - najzelenší ostrov v Atlantiku / azorske ostrovy',
  '4bzhv6ZZNMM': 'Faerské ostrovy 🇫🇴 Krajina, kde príroda hrá hlavnú rolu! 🌿🌊',
  '64HJRlNSzrY': 'Ako bývajú Japonci ? prenajali sme si dom v centre Kjóta Objavuj svet',
  '7F-qcwgdpzc': 'Malta – Valletta z výšky',
  '7Fy8DVKahb4': 'Island očami mamy a dcéry | Recenzia zájazdu s cestovkou Objavuj svet ❄️🔥',
  '7Y0UPF5o8JY':
    'Florencia - Objav paláce Mediciovcov 🏛️ – dynastie, ktorá zmenila dejiny renesancie ✨',
  '7gdmel6uS_k': 'Maldivy - raj na Zemi',
  '7sVcbcFSnks': 'Kaukaz, Gruzinsko',
  '80ybNLiAoZw': 'Jordansko',
  '8YLn0osY8c0': 'Maldivy- raj na Zemi, navstivte ho s nami ! www.objavujsvet.sk',
  '9RSKSNpQYUU': 'Maldivy raj na Zemi, zažite ho v malej skupinke',
  '9X-BCb6DViQ': 'Malta – atmosféra Valletty',
  A5uSUIq6R30: 'Faerské ostrovy z výšky aj zblízka 🌿',
  ANgsVbd7IWo: 'Vianočná Malta – advent pri mori',
  BWHWjx_Paq0: 'Video referencia zo zájazdu v Apúlii 🇮🇹',
  'Ba-iPo5qcOk': 'ananásová plantáž - sao miguel',
  C94GuMnvf6A: 'Azorske ostrovy',
  CKrumt9kUM4:
    'Poznáte mečúňa? Jednu z najzaujímavejších rýb Stredozemného mora! poznavaci zajazd sicilia',
  Cr0Yequ4ZBE: 'Apúlia – Alberobello',
  DCC9yt4WrgU: 'Maldivy',
  DOUFbuLLQDs: 'Katedrala vo Florencii santa maria di fiore',
  'E-1xRpmr3U4': 'Madeira ako ju nepoznáte',
  EcpELsdDhNo: 'Corvo - azorske ostrovy - poklad v strede Atlantiku',
  FVFrstXXcpA: 'Valletta - Malta',
  FouIXLftj6s: 'Ideálny darček z jordánskej Petry',
  'G-tFOld6-Wc': 'Poznávací zájazd Gruzínsko z výšky',
  GJb9Ne7QfEI: 'Aky je ostrov Madeira ?',
  GVcbrvfD774: 'Portugalsko',
  HxZiPC0u6Bo: 'Ako sa dostať na letisko bez stresu',
  IbfHNMz_Vp8: 'Poznavaci zajazd Gruzinsko recenzia',
  J1cDW_KYjnY: 'Prečo si poistiť storno zájazdu',
  'L8wiIPBj-J8': 'Capelinhos / ostrov Faial / azorske ostrovy',
  LIyecHA5PMg: 'Azorské ostrovy - raj v Atlantiku',
  LjlyGwxUEXA: 'Portugalsko – Sintra',
  MIkg0e8YbPY: 'Island - kráľovstvo živlov s Objavuj svet',
  NFs_CDgumjc: 'Portugalsko – zážitky z našich ciest',
  NQ1uOptLqwI: 'Termalne pramene - Caldeira Velha na Azoroch',
  NWyNWELATkw: 'Japonsko – cestujeme v malej skupinke',
  NfQ3p364KI4: 'Reštauracia na Madeire',
  'Nx4iB-_1SZ0': 'Nezabudnuteľné zážitky na ostrove Vulcano s cestovkou objavuj svet',
  OOwEVxHczvw: 'Gejzir na Islande',
  OWlkg8s5wXQ: 'Poďte na Maltu s našou milou kolegynkou Aďkou 🇲🇹',
  OojdzrAuL7A:
    'Najlepší bar v Atlantiku - Peter sports bar OBJAVUJ SVET - s nami v malých skupinkách max 8 ľudí',
  P9Yv3bsfTuo:
    'Bukhara - mesto hodvábnej cesty v Uzbekistane ! Objavujsvet.sk - poznavacky v malých skupinkách',
  QUQyUyg53N0: 'Japonsko – zážitky s Objavuj svet',
  RwPJ5pgRWqY: 'Lávové jazierka v Porto Moniz - Top 10 svetových prírodných kúpalisk',
  S1nHdkSyZtE: 'Apúlia – podpätok Talianska',
  SAeOGGPSljM: 'saliny sicilia najlepsi poznavaci zajazd na siciliu',
  SfK5wTVeMJ8: 'Malta – ochutnajte pastizzi',
  UcPKZKyMrt0: 'Madresa v Buchare / Uzbekistan',
  Uvu4awQePNg: 'Posvätný strom v meste Anuradapura na Srílanke',
  VfAiENZZChI:
    'Matera - Južné Taliansko - OBJAVUJ SVET - poznávacie zájazdy v malých skupinkách :)',
  WJNSgDrjLBM: 'Prales na ostrove Saint Marie, Madagaskar',
  WWxMEjd0Wsk: 'Madeira – Pico do Arieiro',
  WYEFZmTN4EE: 'Sicílske pomaranče 🍊',
  WsaTc71Am68: 'Florencia – zážitky z našich ciest',
  XIXQ2NXsbSE: 'Gruzínsko – Batumi',
  'Xa2bPA-aUJE': 'Ten pocit, keď sa ti splní sen… More, slnko, pokoj a ja.Vitaj na Maldivách',
  XfNXc12cqvE: 'Madagaskar v zajati lemurov ck obajavuj svet',
  Xy7PNRHIXjc: 'Island v malej skupinke',
  Y9LzOCfG_AM: 'Madeira s Objavuj svet',
  YguHNjf27g0: 'Taliansko florencia',
  YpAff0TKL4Q: 'Prečo si VŠETCI zamilujú Sicíliu – poznávací zájazd Sicília.',
  Zlkk_vOTiVM: 'Gruzínsko – zážitky z našich ciest',
  Zxd9CQlX910: '4 dôvody, prečo cestovať v malej skupinke',
  _SAkgb8sICk: 'Island – vodopád Gullfoss',
  _ncbxRd_Ujc: 'Srí Lanka - 🏝️ perla indického oceánu',
  _tcOfbDKzzc: 'Wadi Rum kemp Jordánsko',
  aDHE3aRFEbk: 'Rýchlovlak v Uzbekistane',
  bBQNwsCvKNk: 'Sicília – zážitky z našich ciest',
  c9cTZpRqXT8: 'Island - Krajina ohňa a ľadu',
  cDyIAB0n16A: 'Apúlia- južné Taliansko iJužné Taliansko',
  'cH8qF88Rt-g': 'Cesta po niekdajšom dne Aralského mora / Uzbekistan',
  dypEHjGbIKU: 'Maldivy - raj v indickom oceáne ...',
  el_4o_BNJ2g: 'Madeira – prechádzka po leváde',
  ewtHheXgaAY: 'Sete Cidades',
  f9U4jufjSpU: 'NAdnášanie sa v Mŕtvom mori / Jordánsko',
  fBWNeKUlU4Q: 'FAIAL - prevezieme sa džunglou v strede Atlantiku',
  gUaoKesTX7g: 'Faerske ostrovy / jezero, ktore sa vznasa nad morom',
  gwPYnUn0reE: 'Malta – objavujeme Vallettu',
  'h6wjx-SzTeQ': 'Čím sú Faerské ostrovy špecifické?',
  hNxBQ26aTTA: 'Srí Lanka – zážitky z našich ciest',
  hdqliblRSGY: 'Cestovné zdravotné poistenie vysvetlené',
  jNe2t2P87mo: 'Dom na Madagaskare - ako žijú ľudia',
  jYnsgW6CFOg: 'Japonské záhrady v mestečku Hakone',
  k35Nl2EOYxc: 'Faerské ostrovy – cestujeme v malej skupinke',
  lRjN_1WPaTA: 'Samarkand uzbekistan',
  lyvF02fGHEY: 'Malta – zážitky z našich ciest',
  m4YAgEn0KIs: 'Ubytovanie na Islande',
  mXMB99aO1k4: 'Madeira – ostrov kvetov',
  nbOHRBbIeAE: 'Most cez divokú rieku v Gruzínsku',
  nskCEsw260I: 'Gruzinsko to je pocit ...',
  o2vpeuEPcdQ: 'Muynak - cintorín lodí v Uzbekistane.',
  o8nA_rtTc0s: 'Faerské ostrovy – momenty z našich ciest',
  'ondkeTWc-n4': 'Japonsko – momenty z našich ciest',
  'opPLqOeO5-A': 'Japonsko Ti totálne zmení pohľad na svet — a my ťa tam vezmeme. 🇯🇵✨',
  p16AVG7ySBY: 'Dielňa na výrobu bábok na hranie bábkoherectva / Uzbekistan',
  p6L9NlKOgQo: 'Najstaršia univerzita na svete?Bologna, 1088 !Škola, ktorá prežila stáročia.📚🇮🇹✨',
  pmW1a5XvoUA: 'Piratsky cintorin na ostrove Saint Marie / MAdagaskar',
  rPkjKmPZR34: 'Azorské ostrovy - raj v Európe Objavuj svet',
  s4__46FIvKw: 'Faerské ostrovy – zážitky z našich ciest',
  'sYiB-bCitx8': 'Chorsu - bazar tržnica v Tashkente / Uzbekistan',
  uyA6UphQVfw: 'Lemury na Madagaskare. Poďte ich navštíviť s Objavuj svet',
  vuDYq_C8buo: 'Island - ako u nás funguje zájazd',
  vy0S7Z5EjUY: 'Kronika Gruzinska',
  'w-PJQGTtHS0': 'Prelet ponad Faerskymi ostrovami',
  wiVGkv1Vk2E: 'flores dronom / azorske ostrovy',
  x2ODgkluXdY: 'Apúlia – Castel del Monte',
  xWI1QPCibDc: 'Malta – ochutnajte ftiru',
  y0Jlsb62sUQ: 'Apulia - Juh Talianska',
  y2UWHayaV60: 'Ajurvédsky pobyt v prekrásnom rezorte na Srílanke',
  'yeT-DfXJeYQ': 'Favignana - najkrajsi egadsky ostrov- pozrite si ho s nami na zajazde na Siciliu',
  zfTeJbOWflE: 'Maldivy – zážitky z našich ciest',
  zs95ULzrqaU: 'Alberobello ako z rozprávky – malej skupinke',
};

export const COMPANY_VIDEO_IDS: readonly string[] = [
  '2DkQJVA6hWw',
  'Zxd9CQlX910',
  '3QrvMUf_kik',
  'HxZiPC0u6Bo',
  'hdqliblRSGY',
  'J1cDW_KYjnY',
];

export const DESTINATION_VIDEO_IDS: Readonly<Record<string, readonly string[]>> = {
  madeira: [
    'mXMB99aO1k4',
    'E-1xRpmr3U4',
    '100BW1D3tj8',
    'GJb9Ne7QfEI',
    'NfQ3p364KI4',
    'RwPJ5pgRWqY',
    '20EG869oyk4',
    'Y9LzOCfG_AM',
  ],
  'madeira-hiking': [
    'mXMB99aO1k4',
    'el_4o_BNJ2g',
    'WWxMEjd0Wsk',
    'RwPJ5pgRWqY',
    '100BW1D3tj8',
    'GJb9Ne7QfEI',
    '20EG869oyk4',
    'Y9LzOCfG_AM',
  ],
  island: [
    'c9cTZpRqXT8',
    'vuDYq_C8buo',
    'OOwEVxHczvw',
    'MIkg0e8YbPY',
    'm4YAgEn0KIs',
    '7Fy8DVKahb4',
    'Xy7PNRHIXjc',
    '_SAkgb8sICk',
  ],
  azory: [
    'LIyecHA5PMg',
    'rPkjKmPZR34',
    'L8wiIPBj-J8',
    'wiVGkv1Vk2E',
    '426OXHA0ZZc',
    'fBWNeKUlU4Q',
    'OojdzrAuL7A',
    'EcpELsdDhNo',
  ],
  'sao-miguel': [
    'LIyecHA5PMg',
    'rPkjKmPZR34',
    'ewtHheXgaAY',
    'Ba-iPo5qcOk',
    'NQ1uOptLqwI',
    'C94GuMnvf6A',
  ],
  apulia: [
    'S1nHdkSyZtE',
    'BWHWjx_Paq0',
    'VfAiENZZChI',
    'y0Jlsb62sUQ',
    'x2ODgkluXdY',
    'Cr0Yequ4ZBE',
    'zs95ULzrqaU',
    'cDyIAB0n16A',
  ],
  'sri-lanka': ['_ncbxRd_Ujc', 'Uvu4awQePNg', '-qvtkZNte4w', 'hNxBQ26aTTA'],
  ayurveda: ['y2UWHayaV60'],
  maldivy: [
    '7gdmel6uS_k',
    'DCC9yt4WrgU',
    '0ocZWbWS15Y',
    'zfTeJbOWflE',
    'Xa2bPA-aUJE',
    '9RSKSNpQYUU',
    '8YLn0osY8c0',
    'dypEHjGbIKU',
  ],
  'sri-lanka-maldivy': [
    '_ncbxRd_Ujc',
    'Uvu4awQePNg',
    '-qvtkZNte4w',
    'hNxBQ26aTTA',
    '7gdmel6uS_k',
    'DCC9yt4WrgU',
    '0ocZWbWS15Y',
    '9RSKSNpQYUU',
  ],
  madagaskar: ['pmW1a5XvoUA', 'XfNXc12cqvE', 'jNe2t2P87mo', 'WJNSgDrjLBM', 'uyA6UphQVfw'],
  malta: [
    'FVFrstXXcpA',
    'OWlkg8s5wXQ',
    '7F-qcwgdpzc',
    'gwPYnUn0reE',
    '9X-BCb6DViQ',
    'lyvF02fGHEY',
    'xWI1QPCibDc',
    'SfK5wTVeMJ8',
  ],
  'malta-advent': [
    'ANgsVbd7IWo',
    'FVFrstXXcpA',
    'OWlkg8s5wXQ',
    '7F-qcwgdpzc',
    'gwPYnUn0reE',
    'lyvF02fGHEY',
    'xWI1QPCibDc',
    'SfK5wTVeMJ8',
  ],
  sicilia: [
    'YpAff0TKL4Q',
    'CKrumt9kUM4',
    'Nx4iB-_1SZ0',
    'yeT-DfXJeYQ',
    'SAeOGGPSljM',
    'bBQNwsCvKNk',
    'WYEFZmTN4EE',
  ],
  'west-sicilia': ['YpAff0TKL4Q', 'yeT-DfXJeYQ', 'SAeOGGPSljM', 'bBQNwsCvKNk', 'WYEFZmTN4EE'],
  toskansko: ['YguHNjf27g0', 'WsaTc71Am68', 'p6L9NlKOgQo', 'DOUFbuLLQDs', '7Y0UPF5o8JY'],
  japonsko: [
    '64HJRlNSzrY',
    'jYnsgW6CFOg',
    'QUQyUyg53N0',
    '3BAxGovm5GU',
    'NWyNWELATkw',
    'ondkeTWc-n4',
    'opPLqOeO5-A',
  ],
  jordansko: ['f9U4jufjSpU', 'FouIXLftj6s', '_tcOfbDKzzc', '80ybNLiAoZw'],
  portugalsko: ['GVcbrvfD774', 'LjlyGwxUEXA', 'NFs_CDgumjc'],
  faerske: [
    'h6wjx-SzTeQ',
    'gUaoKesTX7g',
    'A5uSUIq6R30',
    '4bzhv6ZZNMM',
    'w-PJQGTtHS0',
    's4__46FIvKw',
    'k35Nl2EOYxc',
    'o8nA_rtTc0s',
  ],
  gruzinsko: [
    'G-tFOld6-Wc',
    'nbOHRBbIeAE',
    'IbfHNMz_Vp8',
    '7sVcbcFSnks',
    'vy0S7Z5EjUY',
    'Zlkk_vOTiVM',
    'XIXQ2NXsbSE',
    'nskCEsw260I',
  ],
  uzbekistan: [
    'P9Yv3bsfTuo',
    'sYiB-bCitx8',
    'aDHE3aRFEbk',
    'p16AVG7ySBY',
    'UcPKZKyMrt0',
    'cH8qF88Rt-g',
    'o2vpeuEPcdQ',
    'lRjN_1WPaTA',
  ],
};

export const TOUR_VIDEO_DESTINATIONS: Readonly<Record<string, string | null>> = {
  '11': 'madeira',
  '12': 'island',
  '1': 'apulia',
  '10': 'sri-lanka',
  '6': 'maldivy',
  '5': 'sri-lanka-maldivy',
  '14': null,
  '8': 'azory',
  '13': 'sao-miguel',
  '52': 'toskansko',
  '4': null,
  '50': null,
  '59': null,
  '20': null,
  '9': 'faerske',
  '54': null,
  '51': null,
  '25': 'uzbekistan',
  '31': 'gruzinsko',
  '7': 'apulia',
  '3': null,
  '29': 'jordansko',
  '30': 'madagaskar',
  '37': null,
  '44': 'ayurveda',
  '48': null,
  '55': 'portugalsko',
  '62': 'malta',
  '58': null,
  '60': 'japonsko',
  '65': 'uzbekistan',
  '67': 'island',
  '68': 'island',
  '69': 'azory',
  '70': null,
  '71': null,
  '72': null,
  '75': null,
  '76': null,
  '77': 'sicilia',
  '78': 'madeira-hiking',
  '79': null,
  '80': null,
  '81': null,
  '82': 'west-sicilia',
  '83': null,
  '84': null,
  '85': null,
  '86': 'madeira',
  '87': 'malta-advent',
};

export const TOUR_VIDEO_DESTINATIONS_BY_SLUG: Readonly<Record<string, string | null>> = {
  'zajazd-madeira': 'madeira',
  'island-dovolenka': 'island',
  'apulia-podpatok-talianska': 'apulia',
  'srilanka-poznavaci-zajazd': 'sri-lanka',
  maldivy: 'maldivy',
  srilankamaldivy: 'sri-lanka-maldivy',
  'peru-zajazd': null,
  'azory-pralesne-dobrodruzstvo': 'azory',
  'azory-sao-miguel': 'sao-miguel',
  'taliansko-florencia-pisa-bologna-toskansko': 'toskansko',
  andaluzia: null,
  'zajazd-kodan-stockholm': null,
  'ekvador-peru-bolicia-chile': null,
  'cina-zajazd': null,
  'faerske-ostrovy': 'faerske',
  'sokotra-objavovanie': null,
  'zajazd-zanzibar': null,
  'uzbekistan-1': 'uzbekistan',
  'gruzinsko-10': 'gruzinsko',
  'vianocna-apulia': 'apulia',
  'ulet-do-tepla': null,
  jordansko: 'jordansko',
  madagaskar: 'madagaskar',
  norsko: null,
  'ajurvedsky-pobyt': 'ayurveda',
  'kazachstan-kirgizsko': null,
  'portugalsko-lisabon-a-okolie': 'portugalsko',
  malta: 'malta',
  'divoka-patagonia': null,
  japonsko: 'japonsko',
  'uzbekistan-tadzikistan': 'uzbekistan',
  'island-dovolenka-express': 'island',
  'island-komfortne-6': 'island',
  'azory-ostrovy-srdca-atlantiku': 'azory',
  'testovaci-zajazd-cena': null,
  'zajazd-nice-a-okolie': null,
  'spanielsko-inak-baskicko-kantabria-asturia': null,
  gdansk: null,
  'peru-chile': null,
  sicilia: 'sicilia',
  'turisticka-madeira-levady-hory': 'madeira-hiking',
  'brazilia-to-naj-z-brazilie': null,
  laponsko: null,
  sardinia: null,
  'zapadna-sicilia': 'west-sicilia',
  'carovny-londyn': null,
  'azerbajdzan-na-4-dni': null,
  'bosna-a-hercegovina-sarajevo-pyramidy': null,
  'vianocna-madeira-advent': 'madeira',
  'vianocna-malta-advent': 'malta-advent',
};
